import { RanaLegend } from "@/lib/rana-legend";
import { ScenarioFileDescriptor } from "@/types/descriptor-types";

import { CompleteFile } from "../../../types/file-reference-with-file";
import { Layer } from "../../../types/publication";
import { LEGEND_ITEM_GAP } from "../consts/legend-item-gap";

import { LegendLabel } from "./legend-label";

export function ScenarioLegend({ layer, file }: { layer: Layer; file: CompleteFile }) {
  const descriptor = file.file.descriptor as ScenarioFileDescriptor;
  const scenarioLayers = descriptor.meta.layers || [];

  if (!layer.layerInFile) return null;

  const scenarioLayer = scenarioLayers.find((fileLayer) => fileLayer.code === layer.layerInFile);
  if (!scenarioLayer) return null;

  return (
    <RanaLegend
      mb={LEGEND_ITEM_GAP}
      key={scenarioLayer.code}
      descriptorId={descriptor.id}
      layer={scenarioLayer.code}
      title={scenarioLayer.name}
      label={<LegendLabel layer={layer} file={file} />}
      unit={scenarioLayer.label ?? undefined}
    />
  );
}
